import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Row
} from "reactstrap";
import Toastr from "toastr";
import UploadDropzone from "../components/UploadDropzone";
import { useSaveDocStructuringMutation } from "../hooks/useSaveDocStructuringMutation";

const MAX_FILES = 12;

const DocStructuringPage: React.FC = () => {
  const [inputFiles, setInputFiles] = useState<File[]>([]);

  const {
    mutate: saveDocStructuring,
    data: saveDocStructuringResponse,
    isLoading: saveDocStructuringLoading,
    isError: saveDocStructuringError,
  } = useSaveDocStructuringMutation();

  const handleSubmit = () => {
    if (!inputFiles || inputFiles.length === 0) {
      alert("Please upload at least one PDF file");
      return;
    }

    if (inputFiles.length > MAX_FILES) {
      alert(`A maximum of ${MAX_FILES} files are allowed`);
      return;
    }

    // Auto-generate a name so users don't have to type one.
    const firstName = inputFiles[0].name.replace(/\.pdf$/i, "");
    const name =
      inputFiles.length > 1
        ? `${firstName} (+${inputFiles.length - 1} more)`
        : firstName;

    saveDocStructuring({
      files: inputFiles,
      name,
    });
  };

  useEffect(() => {
    if (saveDocStructuringError) {
      Toastr.error("Something went wrong. Please try again later");
    }
  }, [saveDocStructuringError]);

  useEffect(() => {
    if (saveDocStructuringResponse) {
      Toastr.success(
        "Content Parser started! Please check parser executions page for status"
      );
      setInputFiles([]);
    }
  }, [saveDocStructuringResponse]);

  return (
    <>
      <div className="header pb-6 pt-5 pt-md-8"
        style={{
          height: "500px",
          backgroundColor: '#2D315C',
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundImage: "url(/background-header-infinity.jpg)"
        }}
      >
        {/* Mask */}
        <span className="mask bg-gradient-default opacity-8" />
        <Container style={{ display: "flex", flexDirection: "column" }} fluid>
          <Row>
            <Col>
              <div style={{ textAlign: "center" }}>
                <div style={{ display: "inline-block", width: "75%", marginBottom: '10px' }}>
                  <UploadDropzone
                    isFileUploaded={!!saveDocStructuringResponse}
                    setFiles={setInputFiles}
                    accept={['application/pdf']}
                    icon="/file-types-pdf.png"
                    title={`Click/drag and drop up to ${MAX_FILES} PDF files.`}
                  />
                </div>
              </div>
              <div className="text-center">
                {saveDocStructuringLoading ? (
                  <svg height="70px" viewBox="0 0 187.3 93.7" preserveAspectRatio="xMidYMid meet" >
                    <path stroke="rgb(215, 61, 50)" id="outline" fill="none" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"
                      d="M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 				c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z" />
                    <path id="outline-bg" opacity="0.05" fill="none" stroke="#fff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"
                      d="				M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 				c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z" />
                  </svg>
                ) : (
                  <Button
                    color="primary"
                    onClick={handleSubmit}
                    disabled={saveDocStructuringLoading}
                    style={{
                      width: "130px", fontSize: "13px", background: "#FF5252",
                      border: "#FF5252"
                    }}
                    className="btn-sm "
                  >
                    Parse Content
                  </Button>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default DocStructuringPage;
